import { Button } from '@mui/material';
import { useEffect } from 'react';
import { useContext } from './context.jsx';
import { useFields } from '../../hooks/use-fields.js';
import { usePermission } from '../../hooks/use-permission.js';

export function RunRxButton(props) {
  const { open, setSelectedFields, setFocusedModule } = useContext();
  const fields = useFields();
  const selectedFields = props.selectedFields || fields.selectedFields;
  const canRun = usePermission('RUN_RX');

  useEffect(
    () => setSelectedFields(selectedFields),
    [selectedFields, setSelectedFields],
  );

  useEffect(
    () => props.module && setFocusedModule(props.module),
    [props.module, setFocusedModule],
  );

  return canRun ? (
    <Button disabled={!selectedFields.length} onClick={open}>
      {props.children || 'Run Rx'}
    </Button>
  ) : null;
}
